import { render, staticRenderFns } from "./RefuseDialog.vue?vue&type=template&id=54996ce0&scoped=true"
import script from "./RefuseDialog.vue?vue&type=script&lang=js"
export * from "./RefuseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54996ce0",
  null
  
)

export default component.exports